import { render, staticRenderFns } from "./DashboardForm.vue?vue&type=template&id=5f20aefa&"
import script from "./DashboardForm.vue?vue&type=script&lang=ts&"
export * from "./DashboardForm.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports